module.exports = __webpack_public_path__ + "img/logo2.34f694c9.png";